export const AUTH_CONFIG = {
  domain: AUTH_DOMAIN.trim(),
  clientId: AUTH_CLIENT_ID.trim(),
  callbackUrl: AUTH_CALLBACK.trim(),
  apiIdentifier: API_IDENTIFIER.trim()
};
